import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, completionUrl: String }

  copy(event) {
    event.preventDefault()
    event.stopPropagation()

    const original = this.element.innerHTML
    const confirm = () => {
      this.element.textContent = "Copied!"
      setTimeout(() => { this.element.innerHTML = original }, 1500)
    }

    // Native iOS: use WKScriptMessageHandler (works in WKWebView without HTTPS)
    if (window.webkit?.messageHandlers?.nativeClipboard) {
      window.webkit.messageHandlers.nativeClipboard.postMessage(this.textValue)
      confirm()
      this._notifyCompletion()
      return
    }

    // Browser: use Clipboard API with execCommand fallback
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(this.textValue).then(() => {
        confirm()
        this._notifyCompletion()
      }).catch(() => this._fallbackCopy(confirm))
    } else {
      this._fallbackCopy(confirm)
    }
  }

  _fallbackCopy(callback) {
    const el = document.createElement("textarea")
    el.value = this.textValue
    el.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0;"
    document.body.appendChild(el)
    el.focus()
    el.select()
    try {
      document.execCommand("copy")
      callback()
      this._notifyCompletion()
    } catch (e) {}
    document.body.removeChild(el)
  }

  _notifyCompletion() {
    if (!this.hasCompletionUrlValue) return

    fetch(this.completionUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content },
      credentials: "same-origin"
    }).catch((error) => console.warn("[clipboard] completion failed", error))
  }
}
